import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ButterPageType, ButterResponse } from '@app/content/models';
import { APP_CONFIG, AppConfig, Environment } from '@core/models';
import { LocalizationService } from '@core/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ButterService {
  constructor(
    private httpClient: HttpClient,
    private localization: LocalizationService,
    @Inject(APP_CONFIG) private config: AppConfig
  ) {}

  public page<T>(pageType: ButterPageType, slug: string, params?: object): Observable<ButterResponse> {
    return this.httpClient.get<ButterResponse>(`${this.config.butterApiUrl}/pages/${pageType}/${slug}/`, {
      headers: { 'X-TEQ-SITE': '6' },
      params: {
        ...params,
        locale: this.localization.currentLocale,
        preview: this.config.environment === Environment.PROD ? 0 : 1,
        salt: this.config.butterSaltParam || '',
      },
    });
  }

  public collection(collection: string, params?: object): Observable<ButterResponse> {
    return this.httpClient.get<ButterResponse>(`${this.config.butterApiUrl}/collections/${collection}/`, {
      headers: { 'X-TEQ-SITE': '6' },
      params: {
        ...params,
        locale: this.localization.currentLocale,
        preview: this.config.environment === Environment.PROD ? 0 : 1,
        salt: this.config.butterSaltParam || '',
      },
    });
  }
}
